import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';

import Menu from './components/menu/index';
import Login from './pages/login/index'; 
import Dashboard from './pages/dashboard/index';
import ProtectedRoute from './components/auth/ProtectedRoute';

import Agendamentos from './pages/agendamentos/index';

import Operacoes from './pages/operacoes/index'; 
 
import Caixas from './pages/financeiro/caixas'; 
import Comandas from './pages/financeiro/comandas/index'; 
import Maquininhas from './pages/financeiro/cadastros/maquininhas/index';
import Comissoes from './pages/financeiro/comissoes/index';
import Cadastros from './pages/financeiro/cadastros/index';
import Bancos from './pages/financeiro/cadastros/bancos/index';
import Contas from './pages/financeiro/cadastros/contas/index';
import Cartoes from './pages/financeiro/cadastros/cartoes/index';
import GruposDre from './pages/financeiro/cadastros/grupos-dre/index';
import CategoriasFinanceiras from './pages/financeiro/cadastros/categorias-financeiras/index';
import CentrosDeCusto from './pages/financeiro/cadastros/centros-de-custo/index';
import ConfiguracoesFinanceiras from './pages/financeiro/cadastros/configuracoes/index';
import SubLancamentos from './pages/financeiro/cadastros/sublancamentos/index';
import Tags from './pages/financeiro/cadastros/tags/index';
import LancamentosFinanceiros from './pages/financeiro/lancamentos/index';
import Relatorios from './pages/financeiro/relatorios/index'
import ConciliacaoBancaria from './pages/financeiro/conciliacao/index'

import Produtos from './pages/estoque/produtos/index';
import LocaisEstoques from './pages/estoque/locais-estoques/index';
import Fornecedores from './pages/estoque/fornecedores/index';
import PedidosCompra from './pages/estoque/pedidos-compra/index'; 

import Gestoras from './pages/gestoras/index';
import Unidades from './pages/gestoras/unidades/index';

import Pessoas from './pages/pessoas/index'; 

import Servicos from './pages/servicos/index'; 

import Formularios from './pages/anamnese/formularios/index'; 
import Perguntas from './pages/anamnese/perguntas/index'; 
import FormulariosPerguntas from './pages/anamnese/formularios-perguntas/index'; 

import MeuVisagismo from './pages/meu-visagismo/index';
import Configuracoes from './pages/configuracoes/index';
import TiposAcesso from './pages/configuracoes/tipos-acesso';

import Header from './components/header';
import Usuarios from './pages/usuarios';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = localStorage.getItem('token');
    return !!token;
  });
  
  useEffect(() => {
    const handleStorageChange = () => {
      const token = localStorage.getItem('token');
      setIsAuthenticated(!!token);
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('menusUsuario');
    setIsAuthenticated(false);
  };

  return (
    <Router future={{ 
      v7_relativeSplatPath: true,
      v7_startTransition: true
    }}>
      <div className="App">
        <AppContent 
          isAuthenticated={isAuthenticated} 
          onLogin={handleLogin} 
          onLogout={handleLogout}
        />
      </div>
    </Router>
  );
}

function AppContent({ isAuthenticated, onLogin, onLogout }) {
  const location = useLocation();
  
  const showMenu = isAuthenticated && location.pathname !== '/login';
  
  return (
    <>
      {showMenu && (
        <>
          <Header onLogout={onLogout} />
          <Menu onLogout={onLogout} />
        </>
      )}
      <Routes>
        <Route path="/login" element={
          isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLogin={onLogin} />
        } />
        
        <Route
          path="/dashboard"
          element={isAuthenticated ? <ProtectedRoute path="/dashboard"><Dashboard /></ProtectedRoute> : <Navigate to="/login" />}
        />
        
        <Route
          path="/agendamentos"
          element={isAuthenticated ? <ProtectedRoute path="/agendamentos"><Agendamentos /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/caixas"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/caixas"><Caixas /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/abrir-caixa"
          element={<Navigate to="/financeiro/caixas" />}
        />
        <Route
          path="/financeiro/historico-caixas"
          element={<Navigate to="/financeiro/caixas" />}
        />
        <Route
          path="/financeiro/comandas"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/comandas"><Comandas /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/comandas-abertas"
          element={<Navigate to="/financeiro/comandas?tab=abertas" />}
        />
        <Route
          path="/financeiro/comandas-finalizadas"
          element={<Navigate to="/financeiro/comandas?tab=finalizadas" />}
        />
        <Route
          path="/financeiro/comissoes"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/comissoes"><Comissoes /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/estoque/produtos"
          element={isAuthenticated ? <ProtectedRoute path="/estoque/produtos"><Produtos /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/estoque/locais-estoques"
          element={isAuthenticated ? <ProtectedRoute path="/estoque/locais-estoques"><LocaisEstoques /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/estoque/fornecedores"
          element={isAuthenticated ? <ProtectedRoute path="/estoque/fornecedores"><Fornecedores /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/estoque/pedidos-compra"
          element={isAuthenticated ? <ProtectedRoute path="/estoque/pedidos-compra"><PedidosCompra /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/gestoras"
          element={isAuthenticated ? <ProtectedRoute path="/gestoras"><Gestoras /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/gestoras/:gestoraId/unidades"
          element={isAuthenticated ? <ProtectedRoute path="/gestoras/:gestoraId/unidades"><Unidades /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/pessoas"
          element={isAuthenticated ? <ProtectedRoute path="/pessoas"><Pessoas /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/servicos"
          element={isAuthenticated ? <ProtectedRoute path="/servicos"><Servicos /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/anamnese/formularios"
          element={isAuthenticated ? <ProtectedRoute path="/anamnese/formularios"><Formularios /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/anamnese/perguntas"
          element={isAuthenticated ? <ProtectedRoute path="/anamnese/perguntas"><Perguntas /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/anamnese/formularios-perguntas"
          element={isAuthenticated ? <ProtectedRoute path="/anamnese/formularios-perguntas"><FormulariosPerguntas /></ProtectedRoute> : <Navigate to="/login" />}
        />  
        <Route
          path="/operacoes"
          element={isAuthenticated ? <ProtectedRoute path="/operacoes"><Operacoes /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />}
        />
        <Route
          path="/meu-visagismo"
          element={isAuthenticated ? <ProtectedRoute path="/meu-visagismo"><MeuVisagismo /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/maquininhas"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/maquininhas"><Maquininhas /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros"><Cadastros /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/bancos"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/bancos"><Bancos /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/contas"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/contas"><Contas /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/cartoes"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/cartoes"><Cartoes /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/grupos-dre"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/grupos-dre"><GruposDre /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/categorias-financeiras"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/categorias-financeiras"><CategoriasFinanceiras /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/centros-de-custo"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/centros-de-custo"><CentrosDeCusto /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/sublancamentos"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/sublancamentos"><SubLancamentos /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/tags"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/tags"><Tags /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/cadastros/configuracoes"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/cadastros/configuracoes"><ConfiguracoesFinanceiras /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/lancamentos-financeiros"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/lancamentos-financeiros"><LancamentosFinanceiros /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/relatorios"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/relatorios"><Relatorios /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/financeiro/conciliacao"
          element={isAuthenticated ? <ProtectedRoute path="/financeiro/conciliacao"><ConciliacaoBancaria /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/configuracoes"
          element={isAuthenticated ? <ProtectedRoute path="/configuracoes"><Configuracoes /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/configuracoes/tipos-acesso"
          element={isAuthenticated ? <ProtectedRoute path="/configuracoes/tipos-acesso"><TiposAcesso /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route
          path="/usuarios"
          element={isAuthenticated ? <ProtectedRoute path="/usuarios"><Usuarios /></ProtectedRoute> : <Navigate to="/login" />}
        />
        <Route path="*" element={<h1>Página não encontrada</h1>} />
      </Routes>
    </>
  );
}

export default App;
